import type { ActionTree, ActionContext } from 'vuex'
import type { RootState } from '@/store'
import type { LocationState } from './types'
import { LOCATION_MUTATIONS, LOCATION_ACTIONS } from './types'

interface ILocationActions extends ActionTree<LocationState, RootState> {
  [LOCATION_ACTIONS.UPDATE_LOCATION](context: ActionContext<LocationState, RootState>): void
}

const actions: ILocationActions = {
  [LOCATION_ACTIONS.UPDATE_LOCATION]({ commit }) {
    commit(LOCATION_MUTATIONS.START_UPDATING_LOCATION)
    if (!navigator.geolocation) {
      commit(LOCATION_MUTATIONS.DISALLOW_LOCATION)
      commit(LOCATION_MUTATIONS.STOP_UPDATING_LOCATION)
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        commit(LOCATION_MUTATIONS.UPDATE_LOCATION, {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
        commit(LOCATION_MUTATIONS.STOP_UPDATING_LOCATION)
      },
      () => {
        commit(LOCATION_MUTATIONS.DISALLOW_LOCATION)
        commit(LOCATION_MUTATIONS.STOP_UPDATING_LOCATION)
      }
    )
  }
}

export default actions
